import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { useLocalization } from '@shared-ui/localization-context';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkTertiaryButton } from 'uitk-react-button';

const FlatButtonTracked = ClickTracker(UitkTertiaryButton);

export interface GalleryTriggerButtonProps {
  clickHandler?: () => void;
  displayImageCountMessage?: string;
  galleryTriggerRef: any;
  id?: string;
  linkName?: string;
  pathname?: string;
  query?: string;
  trackingRfrr?: string;
}

export const GalleryTriggerButton = ({
  clickHandler,
  displayImageCountMessage,
  galleryTriggerRef,
  id,
  linkName,
  pathname,
  query,
  trackingRfrr,
}: GalleryTriggerButtonProps) => (
  <FlatButtonTracked
    className="gallery-trigger__btn uitk-type-left"
    innerRef={galleryTriggerRef}
    linkName={linkName}
    onClick={clickHandler}
    padding="compact"
    rfrr={trackingRfrr}
    role="button"
    tag={Link}
    to={{ pathname, search: query }}
  >
    <span className="uitk-type-300 uitk-type-medium pwa-theme--color-white gallery-trigger__btn-label">
      {displayImageCountMessage}
      <UitkIcon
        name="photo_library"
        size={UitkIconSize.SMALL}
        title={useLocalization().formatText('hotels.infosite.gallery.viewAll.title')}
        id={`gallery-trigger__${id}-icon`}
      />
    </span>
  </FlatButtonTracked>
);

GalleryTriggerButton.displayName = 'GalleryTriggerButton';
